import React from 'react';

type Props = {
  onCancel: () => void;
  onSave: () => void;
};

export const ButtonsEditMode: React.FC<Props> = ({ onCancel, onSave }) => {
  return (
    <>
      <div className='col-6 col-sm-auto'>
        <button
          onClick={onCancel}
          className='btn btn--medium btn--border-light w-100 w-sm-auto mr-1'
        >
          Cancel
        </button>
      </div>
      <div className='col-6 col-sm-auto'>
        <button onClick={onSave} className='btn btn--medium btn--border-cta w-100 w-sm-auto'>
          Save
        </button>
      </div>
    </>
  );
};
